import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=64e64825&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=64e64825&prod&lang=scss&scoped=true&"
import style1 from "./Stock.vue?vue&type=style&index=1&id=64e64825&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e64825",
  null
  
)

export default component.exports